import React, { useRef, useImperativeHandle, useMemo } from 'react';
import { Image } from '@weareconceptstudio/core';

//* HOC's
import { withUIContext } from '@/context';

//* Style
import FileSectionStyle from './style';

//* Components
import Video from '../Video';

const FileSection = React.forwardRef(
	(
		{
			onLoad,
			file,
			objectFit = 'cover',
			className,
			priority = false,
			double,
			winWidth,
			videoLoop = false,
			playVideo = false,
			icon = true,
			muted = true,
		},
		ref
	) => {
		//! Ref
		const fileRef = useRef();

		//! Imperative Handle
		useImperativeHandle(ref, () => fileRef.current ?? null, []);

		//! Mobile File
		const mobileFile = useMemo(() => {
			return (double && winWidth >= 1280) || !double?.[1]?.src ? double[0] : double[1];
		}, [double, winWidth]);

		return (
			<FileSectionStyle className={`file-section ${className || ''}`}>
				<div className='file-container'>
					{file?.type === 'image' || mobileFile?.type === 'image' ? (
						<Image
							ref={fileRef}
							priority={priority}
							onLoad={onLoad}
							className={objectFit}
							src={file?.src || mobileFile?.src}
							alt={file?.alt || mobileFile?.alt}
						/>
					) : (
						<Video
							onLoad={onLoad}
							muted={muted}
							isIcon={icon}
							loop={videoLoop}
							ref={fileRef}
							autoPlay={playVideo}
							src={file?.src || mobileFile?.src}
						/>
					)}
				</div>
			</FileSectionStyle>
		);
	}
);

FileSection.displayName = 'FileSection';

export default withUIContext(FileSection, ['winWidth']);
